// Modules
import Div100vh from 'react-div-100vh'
import styled from 'styled-components'

interface TemplateContainerProps {
    isPortableSafari?: boolean
}

export const StyledContainer = styled(Div100vh)<TemplateContainerProps>`
    position: relative;
`

export const ContainerContent = styled.section<TemplateContainerProps>`
    overflow: auto;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    padding: 24px 16px 0;
    height: 100%;
`

export const ContainerPage = styled.div<TemplateContainerProps>`
    position: relative;
    max-width: 434px;
    width: 100%;
    height: 100%;
    margin: 0 auto;
`
